import { useTranslation, Trans } from "react-i18next";

import { Dialog } from 'primereact/dialog';

export default function Master({visible, setVisible}) {

    const { t } = useTranslation();

    return(
        <Dialog header={t("master")} visible={visible} style={{ width: '50vw' }} onHide={() => {if (!visible) return; setVisible(false); }} className="masterPanel">
            <Trans i18nKey="masterDetails" />

            <h2 className="text-center titles text-green-500">{t("skills")}</h2>

            <p className="text-center"><Trans i18nKey="masterSkills" /></p>
        </Dialog>
    )
}